import React, { useState } from "react";
import {
  Button,
  Drawer,
  Form,
  Input,
  Upload,
  message,
  Spin,
} from "antd";
import { FileAddOutlined, InboxOutlined } from "@ant-design/icons";
import {mlBulkUpload,pdvSyncAdditionalModal} from './../../services';
import ProgressBar from './../../components/ProgressBar';
const NewModel = (props) => {
  const { Dragger } = Upload;
  const [open, setOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [progState, setProgState] = useState(false);

  const [form] = Form.useForm();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onFinish = async (values) => {


    console.log("Received values of form:", values);

    setLoading(true);

    const thisResponse = await mlBulkUpload(values);

    if(thisResponse.status=="success"){
        console.log(thisResponse);
       const mlFilePaths = thisResponse.data;
        thisResponse.version = values.model_version;
        mlFilePaths["version"] = values.model_version;
        let additionalObj = {};
        additionalObj[values.modal_type] = mlFilePaths;
     
        console.log(additionalObj);

        setProgState(true);
        const devModal  = await pdvSyncAdditionalModal(additionalObj);
        console.log(devModal);

       props.syncTrigger(); 
       setTimeout(()=>{
        message.success("ML Files uploaded successfully.");
        setLoading(false);
        setOpen(false);
        form.resetFields();

      },3500)

    } else {

       setLoading(false);
    }

  };

  const handleCustomRequest = async (options) => {
    const { onSuccess, onError, file } = options;

    // Simulate an asynchronous upload process
    try {
      // Your logic to handle file upload

      // Simulate a successful upload
      setTimeout(() => {
        onSuccess({}, file);
        // message.success(`${file.name} file uploaded successfully.`);
      }, 1000);
    } catch (error) {
      onError(error || "Upload failed");
      message.error(`${file.name} file upload failed.`);
    }
  };

  const handleManualSubmit = async () => {
    try {
      const values = await form.validateFields();

      // Manually call the handleCustomRequest function to upload files
      // for (let i = 0; i < fileList.length; i++) {
      //   const uploadOptions = {
      //     onSuccess: () => {},
      //     onError: () => {},
      //     file: fileList[i],
      //   };

      //   await handleCustomRequest(uploadOptions);
      // }

      // Manually submit the form with the rest of the values
      await onFinish(values);

      // Optionally, you can reset the form and close the drawer
     
    } catch (error) {
      console.error("Error submitting the form manually:", error);
    }
  };

  return (
    <>
     

      <Button
        type="primary"
        style={{
          marginBottom: 15,
          backgroundColor: "#4caf50",
          border: "none",
        }}
        icon={<FileAddOutlined />}
        onClick={showDrawer}
      >
        Add New Model
      </Button>

      <Drawer
        width={600}
        title={(loading ? <ProgressBar forceComplete={progState} /> : "Add New Model" )}
        mask={true}
        placement="right"
        onClose={onClose}
        closable={!loading}
        visible={open}
      >
      
<Spin tip="Uploading ..." spinning={loading}>
        <Form
          form={form}
          onFinish={onFinish}
          // initialValues={{
          //   modal_type: "Pelvic",
          //   model_version: "v1.0",
          // }}
        >
          <Form.Item
            name="modal_type"
            label="Model Type"
            rules={[
              {
                required: true,
                message: "Please enter Model Type",
              },
            ]}
          >
            <Input placeholder="(ex:pelvic,& more...)" />
          </Form.Item>

          <Form.Item
            name="model_version"
            label="ML Version&nbsp;"
            rules={[
              {
                required: true,
                message: "Please input Model Version",
              },
            ]}
          >
            <Input placeholder="(ex:v1.0,& more...)" />
          </Form.Item>

          <Form.Item label="ML Files">
            <Form.Item
              name="ml_files"
              valuePropName="fileList"
              getValueFromEvent={(e) => e && e.fileList}
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    if (!value || value.length === 0) {
                      return Promise.reject(new Error('Please choose at least one file.'));
                    }
                    return Promise.resolve();
                  },
                },
              ]}

              noStyle
            >
              <Upload.Dragger
                name="ml_files"
                multiple
                customRequest={handleCustomRequest}
                beforeUpload={(file) => {
                  setFileList([...fileList, file]);
                  return false;
                }}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single or bulk upload.
                </p>
              </Upload.Dragger>
            </Form.Item>
          </Form.Item>

          <Form.Item className="text-center">
            <Button type="primary" onClick={handleManualSubmit}>
              Upload ML Models
            </Button>
          </Form.Item>
        </Form>
        </Spin>
      </Drawer>
    </>
  );
};

export default NewModel;
